export default [
  {
    "_id": "57fd1747212b87c371f5444c",
    "title": "Новинки Sony на выставке LOUDHEAD 2016",
    "cover": "cover.jpg",
    "link": "/sony",
    "announce": [
        {
          "type": "h3",
          "value": "Не успели попасть в павильон Sony на берлинской IFA? Не надо расстраиваться!"
        },
        {
          "type": "p",
          "value": "Компания Sony Electronics официально подтвердила свое участие в аудио-шоу LOUDHEAD со своими новыми продуктами: флагманским плеером Sony NW-WM1Z, аудиофильскими наушниками Sony MDR-Z1R, а также стационарным и портативным усилителями для наушников – Sony TA-ZH1ES и Sony PHA-2A",
        }
    ],
    "preview": [
      {
        "type": "row",
        "value": [
          {
            "type": "column",
            "size": ['sm12', 'md7'],
            "value": [
              {
                "type": "p",
                "value": "Не успели попасть в павильон Sony на берлинской IFA? Не надо расстраиваться, ведь все экспонаты, которые японцы показали в Берлине, вскоре можно будет посмотреть и пощупать на конференции LOUDHEAD в Москве."
              },
              {
                "type": "p",
                "value": "Компания Sony Electronics официально подтвердила свое участие в аудио-шоу LOUDHEAD со своими новыми продуктами: флагманским плеером Sony NW-WM1Z, аудиофильскими наушниками Sony MDR-Z1R, а также стационарным и портативным усилителями для наушников – Sony TA-ZH1ES и Sony PHA-2A",
              }
            ]
          },
          {
            "type": "column",
            "size": ['sm12', 'md5'],
            "value": [
              {
                "type": "image",
                "value": "/assets/news/57fd1747212b87c371f5444c/IFA2016_2.jpg"
              }
            ]
          }
        ]
      }
    ],
    "description": [
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444c/IFA2016_2.jpg"
      },
      {
        "type": "h3",
        "value": "Не успели попасть в павильон Sony на берлинской IFA? Не надо расстраиваться, ведь все экспонаты, которые японцы показали в Берлине, вскоре можно будет посмотреть и пощупать на конференции LOUDHEAD в Москве."
      },
      {
        "type": "h3",
        "value": "Компания Sony Electronics официально подтвердила свое участие в аудио-шоу LOUDHEAD со своими новыми продуктами: флагманским плеером Sony NW-WM1Z, аудиофильскими наушниками Sony MDR-Z1R, а также стационарным и портативным усилителями для наушников – Sony TA-ZH1ES и Sony PHA-2A",
      },
      {
        "type": "p",
        "value": [{"line": "Чего именно нам ждать от новинок?"}, {"line": "Давайте посмотрим по порядку:"}]
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444c/NW-WM1Z-1.jpg"
      },
      {
        "type": "p",
        "value": ["Новый портативный флагман ", {"b": "Sony Walkman WM-1Z"}, " выглядит настоящим лидером. Солидный корпус из цельной бескислородной меди, отборная аудиофильская начинка начиная с топовых конденсаторов в цепи питания и заканчивая дорогостоящими многожильными кабелями во внутренней проводке. В этом портативном аудиоплеере больше передовых технологий, чем во многих домашних компонентах High End уровня."]
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444c/PHA-2A.jpg"
      },
      {
        "type": "p",
        "value": ["Вместе с Walkman WM-1Z на стенде Sony появится свежий флагманский ЦАП/усилитель ", {"b": "Sony PHA-2A"}, ". Устройство выполнено в прочном алюминиевом корпусе и привлекает внимание эффектным симметричным дизайном, но его основные достоинства спрятаны внутри: встроенный цифроаналоговый преобразователь PHA-2A умеет обрабатывать записи высокой четкости с разрешением до 5,6 МГц (DSD) и 32бит/192кГц (PCM), тактовый генератор отвечает за устранение джиттера, а усилитель работает в сверхшироком частотном диапазоне от инфразвуковых 10 Гц до ультразвуковых 100 кГц, чтобы даже у самого чувствительного аудиогения не возникло вопросов к качеству звука."]
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444c/MDR-Z1R.jpg"
      },
      {
        "type": "p",
        "value": ["Вместе с плеером WM-1Z и усилителем PHA-2A компания показывает еще одну важную флагманскую разработку - топовые High End наушники ", {"b": "Sony MDR-Z1R"}, " с гигантскими 70-миллиметровыми динамиками. Их уникальные диффузоры выполнены из сверхтонкой полимерной пленки с напылением из алюминия и куполами из магния, благодаря чему не деформируются при колебаниях на любой частоте. Ну а дизайн на наш взгляд просто великолепен. Он напоминает легендарные Sony MDR-R10, уверены, что эти наушники возьмут еще немало наград не только в области звука и уникальности акустического оформления, но и в области дизайна."]
      },
      {
        "type": "h3",
        "value": "Компания Sony также объявила о проведении эксклюзивной презентации специально для Loudhead 2016. На ней выступит специальный гость из японской штаб-квартиры Sony – инженер и создатель целого списка легенд среди которых те самые Sony MDR-R10 и известные любому звукорежиссеру эталонные Sony MDR-7506 – Хироаки Сато (Hiroaki Sato).",
      },
      {
        "type": "h3",
        "value": [
          {"line": "Инженер расскажет об истории и прогрессе наушников и звука, а также приоткроет тайны создания и устройства новых моделей флагманской линейки."},
          {"line": "Помимо увлекательного семинара от Хироаки Сато, компания Sony обещает подарки для всех слушателей и призы участникам семинара."}
        ]
      },
      {
        "type": "p",
        "value": [
          {"line": "Время проведения презентации в рамках выставки Loudhead - 29 октября в 14.00"},
          {"line": "Москва КВЦ Сокольники, павильон 7а"}
        ]
      },
      {
        "type": "h3",
        "value": "Зарегистрироваться на презентацию новинок Sony можно на сайте loudhead.ru",
      }
    ],
    "tags": ["sony"],
    "date": "11.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5444e",
    "title": "Знакомьтесь: RHA",
    "cover": "cover.png",
    "preview": [
      {
        "type": "h3",
        "value": "Долгожданный российский дебют знаменитого британского бренда на Loudhead-2016"
      },
      {
        "type": "p",
        "value": "Имя RHA в России все еще известно немногим. А ведь этот породистый британский бренд уже не первый год славится своими внутриканальными наушниками высочайшего уровня! Премиальные материалы и ручная сборка, корпуса из металла и уникальные драйверы собственной разработки - в них есть все, что принято вкладывать в понятие «настоящее английское качество»."
      }
    ],
    "description": [
      {
        "type": "h3",
        "value": "Долгожданный российский дебют знаменитого британского бренда на Loudhead-2016"
      },
      {
        "type": "p",
        "value": "Имя RHA в России все еще известно немногим. А ведь этот породистый британский бренд уже не первый год славится своими внутриканальными наушниками высочайшего уровня! Премиальные материалы и ручная сборка, корпуса из металла и уникальные драйверы собственной разработки - в них есть все, что принято вкладывать в понятие «настоящее английское качество». На счету компании множество самых передовых ноу-хау, включая динамик DualCoil с двумя звуковыми катушками, вставленными одна в другую для максимально точной передачи звука на высоких и низких частотах. На выставке-шоу Loudhead-2016 британцы еамерены показать свои самые свежие разработки."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444e/cl750_banner.jpg"
      },
      {
        "type": "p",
        "value": "Среди них - продвинутые внутриканальные RHA CL750 в корпусах из нержавеющей стали. Их запатентованные воздуховоды Airflow копируют плавные изгибы духовых инструментов, чтобы исключить звуковые искажения из-за трения воздуха. Конструкция магнитов и звуковых катушек в динамиках CL750 оптимизирована для точного контроля над звуком даже на пиках сигнала, а диффузоры переработаны для расширения частотного диапазона. Вот почему эти наушники способны воспроизводить частоты выше 40 кГц и по праву отмечены сертификатом Hi-Res. "
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444e/cl1_banner.jpg"
      },
      {
        "type": "p",
        "value": "Еще больший интерес представляют флагманские модели RHA CL1 Ceramic. В их уникальной конструкции использованы сразу две пары мощных динамиков: к фирменным драйверам CL, отвечающим за бас и средние частоты, добавлены твитеры на запатентованной керамической подложке, выступающие в высокочастотном и ультразвуковом диапазоне. Эти наушники безупречно справляются даже с 45 кГц ультразвуком и отлично подходят для озвучивания аудиофильских хайрезов. Помимо двойного набора динамиков они снабжены двойным набором съемных кабелей: вместе со стандартным кабелем из бескислородной меди в комплект входит балансный кабель с проводниками из серебра."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444e/dacamp_banner.jpg"
      },
      {
        "type": "p",
        "value": "Еще одной свежей разработкой RHA, которую россияне увидят на Loudhead-2016, станет первый портативный ЦАП/усилитель компании - RHA Dacamp L1. В основе его цифроаналоговой схемы - два раздельных ЦАП ESS Sabre 9018k2m для правого и левого каналов. Использование этих продвинутых чипов обеспечивает устройству незаурядные способности к обработке записей с высоким разрешением - до 32бит/384кГц у PCM и до 11.2 МГц у DSD. Помимо компьютеров и ноутбуков прибор готов работать в связке с любыми мобильными девайсами под управлением iOS или Android, а благодаря наличию двух выходов способен поддерживать как обычное, так и балансное подключение наушников. Для тех, кто любит поколдовать над звуком, аппарат оснащен регуляторами высоких и низких частот, а для тех, кто подолгу бывает вдалеке от розетки, вооружен емким аккумулятором на 4000 мАч. Его запаса хватает на 10 часов автономной работы! Вместе с ЦАП/усилителем и другими новинками RHA покажет в России всю линейку своих продуктов от самых демократичных моделей до бескомпромиссных топов. Для тех, кто интересуется по-настоящему качественным портативным звуком, дебют компании на Loudhead-2016 обещает массу интересных открытий!"
      }
    ],
    "tags": [],
    "date": "14.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5444f",
    "title": "Металлическая музыка",
    "cover": "cover.png",
    "preview": [
      {
        "type": "h3",
        "value": "Наушники Focal Utopia с бериллиевыми диафрагмами на Loudhead-2016"
      },
      {
        "type": "p",
        "value": "Французский бренд Focal хорошо известен аудиофилам своей топовой High End акустикой с уникальными динамиками из сверхлегкого редкоземельного бериллия. Теперь компания продвигает свой новый высокотехнологичный High End продукт - топовые головные телефоны Focal Utopia, которые вскоре будут впервые презентованы в России на Loudhead-2016."
      }
    ],
    "description": [
      {
        "type": "h3",
        "value": "Наушники Focal Utopia с бериллиевыми диафрагмами на Loudhead-2016"
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444f/main.jpg"
      },
      {
        "type": "p",
        "value": "Французский бренд Focal хорошо известен аудиофилам своей топовой High End акустикой с уникальными динамиками из сверхлегкого редкоземельного бериллия. Теперь компания продвигает свой новый высокотехнологичный High End продукт - топовые головные телефоны Focal Utopia, которые вскоре будут впервые презентованы в России на Loudhead-2016."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444f/1.png"
      },
      {
        "type": "p",
        "value": "40-миллиметровые динамики этих наушников интересны не только бериллиевыми мембранами, но и сверхтонкими подвесами из синтетических полимеров, а также облегченными звуковыми катушками, выполненными по бескаркасной технологии. Эти неординарные решения позволили конструкторам Focal минимизировать вес подвижных систем в динамиках, чтобы обеспечить им беспрецедентные импульсные характеристики."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444f/2.png"
      },
      {
        "type": "p",
        "value": "Частотный диапазон новых Focal Utopia тоже производит серьезное впечатление, простираясь от инфразвуковых 5 Гц до ультразвуковых 50 кГц. Яркие исполнительские таланты наушников гармонично сочетаются с их солидной внешностью, за которую отвечают карбоновые чашки и амбушюры из натуральной кожи. Полюбоваться незаурядным дизайном Focal Utopia, а главное, оценить качество их звучания, российские аудиофилы смогут уже в ближайшие дни на Loudhead-2016. И это далеко не единственный приятный сюрприз, который ждет посетителей выставки!"
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5444f/3.png"
      }
    ],
    "tags": [],
    "date": "14.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5445a",
    "title": "Чего ждать от Astell&Kern на Loudhead 2016?",
    "cover": "cover.jpg",
    "preview": [
      {
        "type": "h3",
        "value": "Astell& Kern представит свои самые актуальные и полюбившиеся модели плееров и две новинки"
      },
      {
        "type": "p",
        "value": "Один из лидеров в производстве портативных Hi-Fi систем, Astell& Kern представит свои самые актуальные и полюбившиеся модели плееров, включая две новинки, практически одновременно поступившие на российский рынок."
      }
    ],
    "description": [
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445a/main.jpg"
      },
      {
        "type": "p",
        "value": "Один из лидеров в производстве портативных Hi-Fi систем, Astell& Kern представит свои самые актуальные и полюбившиеся модели плееров, включая две новинки, практически одновременно поступившие на российский рынок. Это АК70, в корпусе необычного мятного цвета, и АК300, младшая модель трехсотой серии, которая поддерживает аудио с кодированием до 24 бит / 192 кГц, студийный формат DSD поддерживается с перекодированием в PCM. Кроме того, у всех, кто еще не знаком с флагманским плеером АК380 и линейкой кастомных арматурных наушников второго поколения будет прекрасная возможность послушать этот необычный тандем собственными ушами."
      },
      {
        "type": "p",
        "value": "Плеер Astell&Kern AK70 - это пополнение в серии младших моделей портативных Hi-Fi проигрывателей именитого корейского бренда. По функционалу новинка занимает нишу между плеерами AK JR и AK300, а по дизайну AK70 является уникальным гаджетом, который, несомненно, найдёт почитателей среди ценителей первоклассного звука."
      },
      {
        "type": "p",
        "value": "Новинка поддерживает воспроизведение аудио с кодированием до 24 бит / 192 кГц, студийный формат DSD поддерживается с перекодированием в PCM. В плеере используется один ЦАП – CS4398 от Cirrus Logic, а также 64 Гб встроенной памяти. Устройство имеет как стандартный, так и балансный выход на наушники, а также цифровой выход для работы в режиме USB-ЦАП и USB-аудио."
      },
      {
        "type": "p",
        "value": "AK70 первый среди плееров Astell&Kern поддерживает вывод аудио через USB-порт. Вы можете подключать к AK70 разнообразные портативные усилители с помощью выхода USB. Плеер может транслировать записи в нативном DSD с помощью технологии DoP. Для подключения тех портативных усилителей, которые не обладают поддержкой технологии DoP, используется конвертация DSD в PCM."
      },
      {
        "type": "p",
        "value": "AK70 поддерживает работу в беспроводной сети, объединяющей компьютер, сетевой проигрыватель, мобильные устройства и другие плееры Astell&Kern. Такая конфигурация позволяет искать аудиофайлы на внешних носителях и воспроизводить музыку оттуда, используя Hi-Fi-плеер. Кроме того, AK70 совместим с CD-риппером Astell&Kern, что позволяет при использовании этих устройств вместе с лёгкостью копировать музыку с CD-дисков."
      },
      {
        "type": "p",
        "value": "Помимо вышеперечисленных моделей на Loudhead 2016 удастся подробно изучить такие модели как: ASTELL&KERN AK320, ASTELL&KERN AK380, ASTELL&KERN AK JR, ASTELL&KERN AK ROSIE, ASTELL&KERN AK ANGIE II, ASTELL&KERN AK LAYLA II, ASTELL&KERN AK T1p."
      }
    ],
    "tags": [],
    "date": "22.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5445b",
    "title": "Наследие Квинси Джонса: AKG N90Q на Loudhead-2016",
    "cover": "cover.jpg",
    "preview": [
      {
        "type": "h3",
        "value": "След семейства Джонс чувствуется в каждом компоненте"
      },
      {
        "type": "p",
        "value": "Приближающаяся выставка персонального аудио Loudhead-2016 покажет массу новинок, как среди любительской, так и профессиональной акустики. Посетители смогут протестировать  новые для российского рынка, премиальные наушники с активным шумоподавлением и индивидуальной настройкой звука – AKG N90Q."
      }
    ],
    "description": [
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445b/1.jpg"
      },
      {
        "type": "p",
        "value": "След семейства Джонс чувствуется в каждом компоненте. Если Квинси приложил все своё мастерство к внутренней составляющей наушников, то внешним видом занималась его дочь, Кидада Джонс. Будучи дизайнером The Walt Disney Company, Кидада создала потрясающий дизайн для наушников, осуществив двойную колористику моделей. Наиболее известна золотая оболочка наушников, так и кричащая о своём высоком происхождении. Для аудиофилов с консервативными вкусами также создана модель в абсолютно чёрном цвете. Несмотря на цветовые предпочтения, конструкция AKG N90Q смоделирована самым наилучшим образом. Здесь пользователя ожидают и мягкие амбушюры из овечьей кожи с эффектом памяти, и колесо регулирования звука на одной из чашек, и едва ощутимый вес наушников - всего 40 грамм."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445b/2.jpg"
      },
      {
        "type": "p",
        "value": "Внешняя красота AKG N90Q может в равной степени сравниться только с их содержимым. 52-мм поршневые динамики в купе с разработкой TruNote порадуют слушателя непревзойдённым качеством и высокой четкостью звука абсолютно в любом регистре частотного диапазона. Также, в наушниках установлен ЦАП, воспроизводящий Hi-Res формат без малейшей потери качества, а встроенная батарея продержит заряд наушников на протяжении 12 часов. "
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445b/3.jpg"
      },
      {
        "type": "p",
        "value": "Чтобы узнать более детальные подробности о наушниках, получивших награду \"Best Product Sound on CES 2015\", приходите на Loudhead-2016! Мы ждём Вас!"
      }
    ],
    "tags": [],
    "date": "22.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5445c",
    "title": "Sennheiser PCX 550 Wireless на Loudhead-2016",
    "cover": "cover.png",
    "preview": [
      {
        "type": "h3",
        "value": "Редкая выставка проходит без участия в ней продуктов от знаменитого бренда Sennheiser"
      },
      {
        "type": "p",
        "value": "Редкая выставка проходит без участия в ней продуктов от знаменитого бренда Sennheiser, тем более если это Loudhead-2016. Среди многочисленных именитых новинок от немцев стоит ждать премиальную модель беспроводных наушников Sennheiser PXC 550 Wireless, способных составить достойную партию в каждом путешествии."
      }
    ],
    "description": [
      {
        "type": "h3",
        "value": "Редкая выставка проходит без участия в ней продуктов от знаменитого бренда Sennheiser, тем более если это Loudhead-2016. Среди многочисленных именитых новинок от немцев стоит ждать премиальную модель беспроводных наушников Sennheiser PXC 550 Wireless, способных составить достойную партию в каждом путешествии."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445c/1.jpg"
      },
      {
        "type": "p",
        "value": "Дизайн PXC 550 Wireless отличается строгостью, определенной консервативностью, и как бы подчёркивает серьёзность своего обладателя. Чёрный матовый корпус, плавные переходящие линии складной конструкции, потрясающее качество сборки – от немцев другого ждать не приходится. Наушники сидят очень комфортно, и при условии своего полноразмерного типа, весят всего 227 грамм. В комплекте с наушниками идёт и качественно изготовленный чехол, без которого вряд ли пройдет хотя бы одна поездка. Плюс, внутри также найдётся кабель, необходимый для трансформации наушников из беспроводных в проводные. "
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445c/2.jpg"
      },
      {
        "type": "p",
        "value": "Если в придачу к беспроводной модели вы хотите, чтобы она была и шумоизолирующей, то мимо наушников PXC 550 Wireless на Loudhead-2016 точно не стоит проходить. Такое управление внешним шумом редко доводится встречать. Во-первых, глубину подавления всегда можно отрегулировать. Наушники показывают отличное гашение шума на любой локации: в метро, в торговом центре в сезон скидок, да и просто на улице, забитой людьми и машинами. Во-вторых, наушники отлично демонстрируют себя в тот момент, когда вам нужно ответить на телефонный звонок. Внешний шум снижается, за счёт чего собеседник начинает вас лучше слышать, и одновременно с этим появляется возможность слышать свой голос, чтобы контролировать его громкость."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445c/3.jpg"
      },
      {
        "type": "p",
        "value": "Звучание модели на 100% отвечает репутации компании и статусу «премиум». Несмотря на такие факторы, как Bluetooth и система понижения шума, PXC 550 Wireless удаётся воссоздать натуральное и отличающееся кристальной чистотой звучание. Линия нижнего регистра хорошо ощутима, объёмна, да и в принципе басы всегда считались сильной стороной Sennheiser. Середина выверена, детализация звуковых нюансов прослеживаемся в этом направлении в полной мере. С помощью прилагаемого в комплекте кабеля (с однокнопочным пультом управления и микрофоном), в целом, можно улучшить звучание модели, хотя разница и не будет столь глобальной. Звук прибавит в плотности, добавит красок звуковой сцене, но все это будет улучшением и без того прекрасного звучания. "
      },
      {
        "type": "p",
        "value": "Да и смысл говорить про возможности наушников, когда Вы и сами сможете все послушать и потрогать на приближающейся Loudhead-2016? Увидев Sennheiser PXC 550 Wireless, не забудьте их протестировать. Ждём Вас!"
      }
    ],
    "tags": [],
    "date": "25.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5445d",
    "title": "CustomShop на Loudhead 2016",
    "cover": "cover.png",
    "preview": [
      {
        "type": "h3",
        "value": "В этом году на Loudhead будут представлены одни из наиболее популярных брендов кастомных наушников"
      },
      {
        "type": "p",
        "value": "Еще лет пять назад обзавестись кастомами было затратно не только по деньгам, но еще и по времени. Все лаборатории, занимающиеся их изготовлением, расположены были за рубежом, поэтому надо было проходить процедуру по изготовлению слепков и их отправке за границу. Теперь же кастомная продукция стала намного ближе и доступней благодаря CustomShop от Dr.Head."
      }
    ],
    "description": [
      {
        "type": "h3",
        "value": "В этом году на Loudhead будут представлены одни из наиболее популярных брендов кастомных наушников. Еще лет пять назад обзавестись кастомами было затратно не только по деньгам, но еще и по времени. Все лаборатории, занимающиеся их изготовлением, расположены были за рубежом, поэтому надо было проходить процедуру по изготовлению слепков и их отправке за границу. Теперь же кастомная продукция стала намного ближе и доступней благодаря CustomShop от Dr.Head."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445d/1.jpg"
      },
      {
        "type": "p",
        "value": "Помимо возможности посмотреть и послушать привлекательные модели, всем желающим предложат сделать бесплатный слепок уха, по которому изготавливаются кастомы. Так же всем посетителям, желающим приобрести кастомные наушники гарантируется скидка 10% и скидка 25% на изготовление насадок и беруш. Но и это не все! На стенде CustomShop вы сможете подобрать эксклюзивные кабели фирмы LABKABEL для ваших внутриканальных и кастомных наушников."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445d/2.jpg"
      },
      {
        "type": "p",
        "value": [
          "Подробнее ознакомиться с кастомными наушниками можно ",
          {
            "type": "link",
            "value": "здесь",
            "link": "https://doctorhead.ru/customshop/",
            "target": "_blank"
          }
        ]
      }
    ],
    "tags": [],
    "date": "26.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5445e",
    "title": "JVC Kenwood с новинкой HA-MX100-Z на Loudhead 2016",
    "cover": "cover.png",
    "preview": [
      {
        "type": "h3",
        "value": "Victor Entertainment анонсировала модель мониторных наушников HA-MX100-Z"
      },
      {
        "type": "p",
        "value": "Среди особенностей новинки – технология dual-clear bus port structure, которая обеспечивает оптимизацию давления на передней и задней камерах наушников, что в свою очередь улучшает точность звуковоспроизведения. Так же в HA-MX100-Z установлены драйверы, оснащенные распределителями звука, благодаря которым звуковая сцена становится широкой."
      }
    ],
    "description": [
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445e/1.jpg"
      },
      {
        "type": "p",
        "value": "В перечне новинок мониторных наушников 2016 года компания JVC Kenwood в сотрудничестве со студией Victor Entertainment анонсировала привлекательную модель HA-MX100-Z. Среди особенностей новинки – технология dual-clear bus port structure, которая обеспечивает оптимизацию давления на передней и задней камерах наушников, что в свою очередь улучшает точность звуковоспроизведения. Так же в HA-MX100-Z установлены драйверы, оснащенные распределителями звука, благодаря которым звуковая сцена становится широкой."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445e/3.jpg"
      },
      {
        "type": "p",
        "value": "Характеристики представляемой модели наушников претендуют на категорию профессиональных мониторов. Чувствительность HA-MX100-Z составляет 107 дБ, диапазон воспроизводимых частот простирается от 10 Гц до 40 КГц, импеданс составляет 56 ом, максимальная допустимая мощность — 1,5 ватта. Несмотря на то что эта модель позиционируется как профессиональные мониторные наушники, первичным разъёмом у HA-MX100-Z является привычный 3,5-мм «мини-джек». Так же и по параметрам веса они отличаются от своих «профессиональных коллег». Их вес всего 265 граммов."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445e/2.jpg"
      },
      {
        "type": "p",
        "value": "Приходите на Loudhead 2016 чтобы оценить их по достоинству!"
      }
    ],
    "tags": [],
    "date": "26.10.2016"
  },
  {
    "_id": "57fd1747212b87c371f5445f",
    "title": "Ультракомпактные Final F7200 на Loudhead 2016!",
    "cover": "cover.png",
    "preview": [
      {
        "type": "h3",
        "value": "Маленькие и ультралегкие наушники для точной посадки и высококачественной звукопередачи"
      },
      {
        "type": "p",
        "value": "Сверхплотная посадка наушников в ушном канале для оптимальных звуковых характеристик, более широкой звуковой картины и передачи богатых басов. Эти наушники отвечают всем вашим требованиям и не только!"
      }
    ],
    "description": [
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445f/1.jpg"
      },
      {
        "type": "p",
        "value": "Маленькие и ультралегкие наушники для точной посадки и высококачественной звукопередачи. Сверхплотная посадка наушников в ушном канале для оптимальных звуковых характеристик, более широкой звуковой картины и передачи богатых басов. Эти наушники отвечают всем вашим требованиям и не только!"
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445f/2.png"
      },
      {
        "type": "p",
        "value": "Возможность расположения драйвера наушника значительно глубже в ушном канале позволяет добиться более реалистичного звучания невероятно высокого качества. Для этого был существенно уменьшен корпус наушников F7200, сократив при этом и количество составляющих конструкцию элементов. Несмотря на то, что наушники выполнены из нержавеющей стали, их вес составляет всего 2 грамма, а диаметр не превышает 5,5 мм. Их конструкция исключает нежелательную вибрацию и позволяет насладиться невероятно чистым звучанием сигнала. Уникальный способ разработчиков Final использовать полнодиапазонные балансные арматурные драйверы во всех моделях обеспечивает потрясающее наполнение звука басами, неожиданное для наушников такого размера. Одной из последних разработок является кабель с серебряным напылением, способный создать более широкую звуковую картину. Данный кабель является съемным, что позволит подключить опциональные кабели с MMCX коннекторами. Наушники оборудованы заушным крючком, способствующим сокращению микрофонного эффекта кабеля. Эти наушники - флагман компании Final - воплощают в себе все аспекты высококачественного воспроизведения звука и простоту использования."
      },
      {
        "type": "image",
        "value": "/assets/news/57fd1747212b87c371f5445f/3.jpg"
      },
      {
        "type": "p",
        "value": "Посетите выставку Loudhead 2016 и познакомьтесь поближе с другими моделями из новой линейки Final!"
      }
    ],
    "tags": [],
    "date": "26.10.2016"
  }
];



/** WEBPACK FOOTER **
 ** ./src/store/news.tsx
 **/